import { stepUpOptions, stepUpVerify, type ApiClient, type PublicKeyRequestOptionsJson } from '@aithora/shared';
import { getPasskeyAssertion, passkeysSupported } from '../../auth/webauthn';

/**
 * "Confirm with Face ID or passkey" (Spec V4 16 F and G): a fresh passkey assertion for the
 * signed-in person, exchanged for a one-time step-up token (5 minutes, single use) that a
 * protected write sends with it. The server checks the token again; nothing here is trusted.
 */
export async function passkeyStepUp(client: ApiClient): Promise<string> {
  if (!passkeysSupported()) throw new Error('This browser cannot use a passkey. Use the Aithora app, or a browser with Face ID or a security key.');
  let opts: PublicKeyRequestOptionsJson;
  try {
    opts = (await stepUpOptions(client, { body: {} })) as unknown as PublicKeyRequestOptionsJson;
  } catch (e) {
    const err = e as { noPasskey?: boolean; message?: string; body?: { noPasskey?: boolean } };
    if (err.noPasskey || err.body?.noPasskey) throw new Error('You have no passkey yet. Add one in Two-factor first.');
    throw e;
  }
  const response = await getPasskeyAssertion(opts);
  const out = await stepUpVerify(client, { body: { response } });
  return out.stepUpToken;
}
